<template>
  <div class="whaty_select">
    <el-select
      v-model="selectValue"
      :placeholder="placeholder"
      :size="size"
      filterable
      clearable
      remote
      :remote-method="remoteMethod"
      :loading="loading"
      @focus="handleFocus"
      @change="handleChange"
    >
      <el-option
        v-for="op in selectData"
        :key="op[0]"
        :value="op[valueIndex]"
        :label="op[labelIndex]"
      >
        <span v-html="hightlight(op[labelIndex])"></span>
      </el-option>
    </el-select>
  </div>
</template>
<script>
  import util from '../../libs/util'
  export default {
    name: 'whaty-select',
    props: {
      value: {
        required: true
      },
      size: {
        type: String,
        default: 'mini'
      },
      placeholder: {
        type: String
      },
      url: String,
      queryParams: {
        type: Object,
        default() {
          return {}
        }
      },
      valueIndex: {
        type: Number,
        default: 0
      },
      labelIndex: {
        type: Number,
        default: 1
      }
    },
    data() {
      return {
        selectValue: '',
        selectData: [],
        loading: false,
        query: ''
      }
    },
    created() {
      this.selectValue = this.value
    },
    methods: {
      remoteMethod(query) {
        if (query && query.trim()) {
          this.query = query.trim()
          this.loading = true
          let params = this.queryParams
          params.query = this.query
          util.ajax.post(this.url, {params}).then((res) => {
            if (res.data.meta.errCode === 0) {
              this.selectData = res.data.data
              this.$emit('select-data-change', this.selectData)
            }
            this.loading = false
          }).catch((err) => {
            this.loading = false
            console.warn('获取下拉框数据失败: ' + params)
            console.error(err)
          })
        } else {
          this.selectData = []
          this.$emit('select-data-change', this.selectData)
        }
      },
      handleFocus() {
        if (!this.selectValue || !this.selectValue.trim()) {
          this.selectData = []
          this.$emit('select-data-change', this.selectData)
        }
      },
      handleChange(val) {
        this.selectValue = val
        this.$emit('input', val)
        this.$emit('change', val)
      },
      hightlight(value) { // 搜索关键字高亮
        return value.replace(this.query, '<b class="highlight">' + this.query + '</b>')
      }
    },
    watch: {
      value: function (newValue) {
        this.selectValue = newValue
      }
    }
  }
</script>
<style lang="scss">
  .whaty_select {
    height: 100%;
    .el-select {
      input{
        display: block;
        width: 100%;
        height: 32px;
        padding: 0 24px 0 12px;
        font-size: 14px;
        color: #616365;
        background-color: white;
        background-image: none;
        border: 1px solid #DCDFE6;
        border-radius: 4px;
        -webkit-transition: 0.15s;
        transition: 0.15s;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;

        &::-moz-placeholder {
          color: #313335;
        }

        &::-ms-input-placeholder {
          color: #313335;
        }

        &::-webkit-input-placeholder {
          color: #313335;
        }
      }
      .el-input .el-input__icon {
        line-height: 32px;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/whaty-select/whaty-select.vue